// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "figure.image\n{\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\nfigure > img {\n  height: unset;\n}\n", ""]);
// Exports
module.exports = exports;
